<template>
  <div class="percentageIndicator">
    <div class="percentageIndicator__indicator">
      <div :class="percentageClasses" :style="`width: ${width}%`" />
    </div>
    <sc-flex
      :is-y-centered="true"
      :is-x-centered="true"
      :gap="4"
      class="percentageIndicator__text"
    >
      <div v-if="isLocked" class="percentageIndicator__icon">
        <sc-icon name="lock" size="small"></sc-icon>
      </div>
      <sc-tiny color="currentcolor" class="percentageIndicator__label"
        ><b><slot /></b
      ></sc-tiny>
    </sc-flex>
  </div>
</template>

<script>
import SxTiny from './SxTiny';

export default {
  components: {
    SxTiny,
  },
  props: {
    total: {
      type: Number,
      required: true,
    },
    count: {
      type: Number,
      required: true,
      default: 0,
    },
    isCompleted: {
      type: Boolean,
      required: true,
      default: false,
    },
    isInProgress: {
      type: Boolean,
      required: true,
      default: false,
    },
    isOpened: {
      type: Boolean,
      required: true,
      default: false,
    },
    isLocked: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  computed: {
    percentageClasses() {
      const pClasses = new Set(['percentageIndicator__indicator__bar']);

      if (this.isCompleted)
        pClasses.add('percentageIndicator__indicator__bar--completed');
      else if (this.total === 0)
        pClasses.add('percentageIndicator__indicator__bar--empty');

      return [...pClasses].join(' ');
    },
    width() {
      if (this.isCompleted) return 100;

      const steps = this.total || 0;
      const count = this.count || 0;
      const percentageComplete = Math.round((count / steps) * 100);

      return percentageComplete || (this.isInProgress && 5) || 0;
    },
  },
};
</script>

<style scoped>
.percentageIndicator {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 4px;

  color: var(--gray-800);

  white-space: nowrap;
}

.percentageIndicator__indicator {
  position: relative;

  height: 4px;
  overflow: hidden;
  min-width: 96px;
  max-width: 96px;
  width: 100%;

  background-color: var(--gray-100);
  border-radius: 4px;
}

.percentageIndicator__indicator__bar {
  position: absolute;

  height: 100%;

  background-color: var(--blue-500);
}

.percentageIndicator__indicator__bar--completed {
  background-color: var(--green-500);
}

.percentageIndicator__indicator__bar--empty {
  background-color: var(--gray-200);
}

.percentageIndicator__text svg {
  color: var(--gray-800);
}

.percentageIndicator__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  width: 20px;

  background-color: var(--gray-100);
  border-radius: 4px;
}
</style>
